module.exports = __webpack_public_path__ + "img/vk.ac14c24c.svg";